<script setup>
import { HCol, HRow } from '@pixul/hephaestus';
import Config         from '@/config';
import dayjs          from 'dayjs';
</script>

<template>
  <HRow
    class='background--blue-400 padding-6'
    justify-content='center'
  >
    <HCol
      align-items='center'
      class='text-white text-xs'
    >
      <p>
        <span class='text-bold text-uppercase'>{{ Config.title }}</span>
        v.{{ Config.version }}
      </p>
      <p>by <span class='text-uppercase'>{{ Config.pixulName }}</span> {{ dayjs().year() }}</p>
    </HCol>
  </HRow>
</template>

<script>
export default {
  name : 'FooterVersion'
};
</script>

